import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useTenant from "../../../hooks/useTenant";
import SearchableAutoComplete from "../../../components/SearchableAutoComplete";
import FilterReset from "../../../components/FilterReset";
import {
  invoiceStatusOptions,
  convertedValue,
  searchPayload,
  formatDate,
} from "../../../utils/common";
import ReactHookFormSelect from "../../../components/ReactHookFormSelect";
import CustomTextField from "../../../components/CustomTextField";
import { useDialog } from "../../../contexts/DialogContext";
import usePlan from "../../../hooks/usePlan";
import CustomDatePicker from "../../../components/CustomDatePicker";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const today = formatDate(new Date());

  const initialValues = {
    userName: "",
    createdBy: "",
    startDate: null,
    startDateStr: "",
    endDate: null,
    endDateStr: "",
  };

  const { fields, payload, setPayload, setFilterResetFunc, filterFormData, setFilterFormData } =
    props;

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: filterFormData || initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => () => reset(initialValues));
  }, [reset]);

  const onSubmit = async (data) => {
    try {
      setFilterFormData(data);

      let filters = [];

      if (data.userName) {
        filters.push({
          fieldName: "userName",
          fieldValue: data.userName,
          op: "like",
          dataType: "string",
          condition: "and",
          isJoin: true,
          entityName: "RadUserEntity",
          attributeName: "radUser",
        });
      }

      if (data.startDate) {
        filters.push({
          fieldName: "startDate",
          fieldValue: data.startDateStr,
          op: "btn",
          dataType: "date",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.endDate) {
        filters.push({
          fieldName: "endDate",
          fieldValue: data.endDateStr,
          op: "btn",
          dataType: "date",
          condition: "and",
          isJoin: false,
        });
      }

      if (data.createdBy) {
        filters.push({
          fieldName: "createdBy",
          fieldValue: data.createdBy,
          op: "eq",
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }

      setPayload((prev) => ({
        ...prev,
        filters,
      }));

      unSetDialog("advance_filter");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={6} pt={6}>
            <Grid item md={6} sm={6} xs={12}>
              <CustomTextField
                label={t("customer_name")}
                name="userName"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <CustomTextField
                label="Created By"
                name="createdBy"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <CustomDatePicker
                name="startDate"
                nameTemp="startDateStr"
                label="Start Date"
                range={true}
                control={control}
              />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <CustomDatePicker
                name="endDate"
                nameTemp="endDateStr"
                label="End Date"
                range={true}
                control={control}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={() => reset(initialValues)} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}
export default AdvanceFilter;
